import React from 'react';
import {Box, CircularProgress, Grid} from "@material-ui/core";
import {FormWrapper, SubmitBtnMerchant} from "../../../../../../helpers/FormHandlers";
import {
  apiV2SettlementsAndRefundsGet,
  apiV2SettlementsAndRefundsSet
} from "../../../../../../../api/merchant/settlementsAndRefunds";
import {MerchantInput, MerchantSelect, MerchantSwitch} from "../../../../../../helpers/InputsHelpers";
import FORM_SCHEMA from './constants/schema';
import SETTLEMENT_CYCLE_ITEMS from './constants/cycleItems';

export default () => {
  const [loading, setLoading] = React.useState(true);
  const [data, setData] = React.useState({});

  React.useEffect(() => {
    setLoading(true);

    apiV2SettlementsAndRefundsGet()
        .then((res) => {
          setData({
            reserved: res.reserved || false,
            days: res.reserved_days || '',
            cycle: res.cycle || SETTLEMENT_CYCLE_ITEMS[1].id,
          });
        }).finally(() => {
          setLoading(false);
        })
  }, []);

  if (loading) {
    return (
      <Box>
        <CircularProgress size="2.5rem" color="inherit" />
      </Box>
    )
  }

  return (
    <FormWrapper
      data={data}
      schema={FORM_SCHEMA}
      onSubmit={(data) => (
        apiV2SettlementsAndRefundsSet({
          refund_reserved: data.reserved,
          refund_reserve_day: Number(data.days),
          settlement_cycle: data.cycle,
        })
      )}
      resultModalData={['Settings have been changed']}
    >{(formCtx) => {

      const data = formCtx.state.data || {};
      const reserved = data.reserved;

      return (
        <>
          <Grid container spacing={4}>
            <Grid item md={6} xs={12}>
              <Box display="flex" justifyContent="space-between" alignItems="flex-end">
                <Box>
                  <MerchantSwitch
                    label="Refund period"
                    text="Enable refund reserve"
                    name="reserved"
                    formCtx={formCtx}
                  />
                </Box>
                <Box display="flex" alignItems="center">
                  <Box width="9.5rem">
                    <MerchantInput
                      name="days"
                      formCtx={formCtx}
                      disabled={!reserved}
                      disableLabel
                    />
                  </Box>
                  <Box ml="1.2rem">
                    Days
                  </Box>
                </Box>
              </Box>
              <Box mt="3rem">
                <b className="fw7">Note: </b>
                The refund reserve will be used for refunding invoices
                (e.g. return of the product by the customer, refund initiated by the retailer).
                The refund reserve is held in a local fiat currency (eg. EUR, GBP, USD)
                to fund refund requests in cryptocurrency. Once the refund period is set,
                Lunu will not settle the refund reserve amount for the agreed refund period.
              </Box>
            </Grid>
            <Grid item md={6} xs={12}>
              <MerchantSelect
                label="Settlement cycle"
                name="cycle"
                propName="name"
                propValue="id"
                items={SETTLEMENT_CYCLE_ITEMS}
                formCtx={formCtx}
              />
              <Box mt="3rem">
                <b className="fw7">Note: </b>
                The minimum withdrawal amount is 100 EUR or an equivalent in the local currency.
                A daily settlement cycle means batch-based settlements every day at 6 PM CET.
                Similarly, weekly, bi-weekly, and monthly cycles enable settlements at 6 PM CET
                on the last working day of a week, every other week, or month.
              </Box>
            </Grid>
          </Grid>
          <Box maxWidth="27rem" mt="4rem">
            <SubmitBtnMerchant formCtx={formCtx}>
              Save Settings
            </SubmitBtnMerchant>
          </Box>
        </>
      )
    }}</FormWrapper>
  )
}
